import { takeLatest, all } from "redux-saga/effects";
import { SAGA_ACTIONS } from "../_config";

import {
  checkValidToken,
  forgotPassword,
  getRegistrationFieldsData,
  getUserProfile,
  loginUser,
  loginUserWithOtp,
  loginWithEmail,
  logoutUser,
  registration,
  resetPassword,
  updateDisplayName,
  updateUserProfile,
} from "./userSaga";

import {} from "./commonSaga";

import {
  getEventList,
  getEventGameList,
  getEventSponsorsList,
  getEventGameDetails,
  getUpcomingEventList,
  joinEventGame,
  viewLeaderBoard,
  getMenus,
  getGameDetails,
} from "./eventSaga";

import { getCmsContent, getGameCms } from "./cmsSaga";

export function* sagas() {
  yield all([
    // user saga
    takeLatest(SAGA_ACTIONS.USER.DETAILS, getUserProfile),
    takeLatest(SAGA_ACTIONS.USER.LOGIN, loginUser),
    takeLatest(SAGA_ACTIONS.USER.LOGIN_WITH_OTP, loginUserWithOtp),
    takeLatest(SAGA_ACTIONS.USER.LOGIN_WITH_EMAIL, loginWithEmail),
    takeLatest(SAGA_ACTIONS.USER.FORGOT_PASSWORD, forgotPassword),
    takeLatest(SAGA_ACTIONS.USER.RESET_PASSWORD, resetPassword),
    takeLatest(SAGA_ACTIONS.USER.REGISTRATION, registration),
    takeLatest(SAGA_ACTIONS.USER.UPDATE_PROFILE, updateUserProfile),

    takeLatest(SAGA_ACTIONS.USER.LOGOUT, logoutUser),
    takeLatest(SAGA_ACTIONS.USER.UPDATE_DISPLAY_NAME, updateDisplayName),
    takeLatest(SAGA_ACTIONS.USER.CHECK_VALID_TOKEN, checkValidToken),
    takeLatest(SAGA_ACTIONS.USER.REGISTRATION_FIELDS, getRegistrationFieldsData),

    //Event Saga
    takeLatest(SAGA_ACTIONS.EVENT.GET_EVENT_LIST, getEventList),
    takeLatest(SAGA_ACTIONS.EVENT.GET_EVENT_GAME_LIST, getEventGameList),
    takeLatest(SAGA_ACTIONS.EVENT.GET_SPONSORS_LIST, getEventSponsorsList),

    takeLatest(SAGA_ACTIONS.EVENT.GET_EVENT_GAME_DETAILS, getEventGameDetails),
    takeLatest(SAGA_ACTIONS.EVENT.GET_UPCOMING_EVENT, getUpcomingEventList),
    takeLatest(SAGA_ACTIONS.EVENT.JOIN_EVENT_GAME, joinEventGame),
    takeLatest(SAGA_ACTIONS.EVENT.LEADERBOARD, viewLeaderBoard),
    takeLatest(SAGA_ACTIONS.EVENT.GET_MENUS, getMenus),
    takeLatest(SAGA_ACTIONS.EVENT.GET_GAME_DETAILS, getGameDetails),

    //CMS Saga
    takeLatest(SAGA_ACTIONS.CMS.GET_CMS, getCmsContent),
    takeLatest(SAGA_ACTIONS.CMS.GET_GAME_CMS, getGameCms),
  ]);
}
